

const API_KEY = "d333ff51bddbac02d486e00ec8e10c0e"

const reqParams = {

    topTrending : `https://api.themoviedb.org/3/trending/all/week?api_key=${API_KEY}`,
    NetflixOriginals: `https://api.themoviedb.org/3/discover/tv?api_key=${API_KEY}&with_networks=213`,
    topRatedMovies: `https://api.themoviedb.org/3/movie/top_rated?api_key=${API_KEY}&language=en-US`,
    topRatedTvShows : `https://api.themoviedb.org/3/tv/top_rated?api_key=${API_KEY}&language=en-US`,
    ActionMovies: `https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&with_genres=28`,
    ComedyMovies: `https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&with_genres=35`,
    HorrorMovies : `https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&with_genres=27`,
    RomanticMoves : `https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&with_genres=10749`,
    Documentaries : `https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&with_genres=99`,
    HindiMovies : `https://api.themoviedb.org/3/discover/movie?api_key=${API_KEY}&with_original_language=hi`,
    SingleMovie: `https://api.themoviedb.org/3/movie`,
    Singletvshow: `https://api.themoviedb.org/3/tv`

}

export default reqParams;